<template>
	<v-card color="transparent" flat>
		<v-row>
			<v-col>
				<p class="overline">Options</p>
				<v-row class="pl-2">
					<v-switch v-model="question.hidden" label="Hidden" class="mr-4"></v-switch>
					<v-switch v-model="question.isRequired" label="Required" class="mr-4"></v-switch>
					<v-switch v-model="question.isReadOnly" label="Read only" class="mr-4"></v-switch>
					<v-switch v-model="question.excludeFromProfiles" label="Exclude from profiles" class="mr-4"></v-switch>
				</v-row>
				<!-- <v-row>
					<v-col cols="12" sm="6">
						<v-text-field hint="Make sure you enable URL params on the front page." label="URL param for this field" v-model="question.urlParam"></v-text-field>
					</v-col>
				</v-row> -->
			</v-col>
		</v-row>
	</v-card>
</template>


<script> 
export default {
	name: "StandardOptions", 
	props: {
		question: {type: Object}
	}, 
	components:{
	},
	watch: {
		question(question){
			if( question.hidden == true ){
				question.visible = false;
			}
			else {
				question.visible = true;
			}
		}
	}
} 
</script>